import { render, staticRenderFns } from "./HomeBottombannerFrame.vue?vue&type=template&id=251c41f5&scoped=true&"
import script from "./HomeBottombannerFrame.vue?vue&type=script&lang=js&"
export * from "./HomeBottombannerFrame.vue?vue&type=script&lang=js&"
import style0 from "./HomeBottombannerFrame.vue?vue&type=style&index=0&id=251c41f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c41f5",
  null
  
)

export default component.exports